import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { IIcon } from '../icon/icon.interface';
import { IconSizesEnum } from '../icon/icons-sizes.enum';

@Component({
  selector: 'app-checkmark',
  templateUrl: './checkmark.component.html',
  styleUrls: ['./checkmark.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CheckmarkComponent implements OnInit {
  @Input() iconSize: IconSizesEnum = IconSizesEnum.small;

  checkmarkIcon: IIcon;

  constructor() {}

  ngOnInit() {
    this.checkmarkIcon = {
      name: 'checkmark',
      size: this.iconSize,
    };
  }
}
